const isLocalhost = typeof window !== "undefined" && window.location.hostname === "localhost";

export const msalConfig = {
  auth: {
    clientId: import.meta.env.VITE_MSAL_CLIENT_ID || "e6761a82-7908-49e6-980d-68fb79ea49d3",
    authority: `https://login.microsoftonline.com/${import.meta.env.VITE_MSAL_TENANT_ID || "05d75c05-fa1a-42e7-9cf1-eb416c396f2d"}`,
    redirectUri: isLocalhost
      ? "http://localhost:3001"
      : "https://afrdigitalassistant-afrpoc.westeurope.dev.maersk.io",
    postLogoutRedirectUri: isLocalhost
      ? "http://localhost:3001"
      : "https://afrdigitalassistant-afrpoc.westeurope.dev.maersk.io",
  },
  cache: {
    cacheLocation: "sessionStorage",
    storeAuthStateInCookie: false,
  },
};

export const loginRequest = {
  scopes: ["openid", "profile", "email"],
};
